import { useCall } from "@/hooks/useCall/useCall";
import { useHasLineWithLanguages } from "@/hooks/useHasLineWithLanguages/useHasLineWithLanguages";

import { FEATURE_NAME } from "@/components/LicenseGuard/LicenseGuard.constant";
import { useHasLicenseAccess } from "@/components/LicenseGuard/useHasLicenseAccess";
import { useHasCcAccess } from "../useHasCcAccess/useHasCcAccess";

export const useShouldDisplayPromotionalBanner = () => {
  const { call } = useCall();

  const { hasLine } = useHasLineWithLanguages({
    languages: ["en-*", "fr-*", "es-*", "it-*", "nl-*", "de-*"],
  });
  const hasCcAccess = useHasCcAccess();
  const hasAiStandardAccess = useHasLicenseAccess({
    feature: FEATURE_NAME.AI_STANDARD_ACCESS,
  });

  return [
    hasCcAccess,
    hasLine,
    !hasAiStandardAccess,
    Boolean(call?.transcription),
  ].every(Boolean);
};
